import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as authDataActionCreators from 'src/explore/data/auth/actions';
import Form from './elements/Form';
import Success from './elements/Success';

export class ForgotPassword extends Component {
  state = {
    email: null,
    loading: false,
    success: false,
  };

  handleSubmit = ( params ) => {
    const { forgotPassword } = this.props;

    this.setState({ loading: true, email: params.email });

    forgotPassword( params )
      .then(() => {
        this.setState({ success: true, loading: false });
      })
      .catch(() => {
        this.setState({ success: false, loading: false });
      });
  };

  onSubmit = ( params ) => {
    const { forgotPassword } = this.props;

    this.setState({ loading: true, email: params.email });

    forgotPassword( params )
      .then(() => {
        this.setState({ success: true, loading: false });
      })
      .catch(() => {
        this.setState({ success: false, loading: false });
      });
  };

  render() {
    const { btnClass, defaultEmail, linkClass, onBack, onClose } = this.props;
    const { email, loading, success } = this.state;

    return (
      <>
        {!success && (
          <Form
            btnClass={btnClass}
            initialValues={{ email: defaultEmail }}
            linkClass={linkClass}
            loading={loading}
            onSubmit={this.handleSubmit}
            onBack={onBack}
          />
        )}
        {success && <Success btnClass={btnClass} email={email} onAccept={onClose} />}
      </>
    );
  }
}

export default connect(
  null,
  {
    forgotPassword: ( params ) => authDataActionCreators.forgotPassword( params ),
  },
)( ForgotPassword );
